import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BulkRecreateOrdersService implements OnDestroy {


  private _referenceNumbers$ = new BehaviorSubject<string[]>([]);
  referenceNumbers$ = this._referenceNumbers$.asObservable();
  set referenceNumbers(value: string[]) {
    this._referenceNumbers$.next(value);
  }

  private _recreateOrdersResponse$ = new BehaviorSubject<BulkRecreateOrderResponse[]>([]);
  recreateOrdersResponse$ = this._recreateOrdersResponse$.asObservable();
  set recreateOrdersResponse(value: BulkRecreateOrderResponse[]) {
    this._recreateOrdersResponse$.next(value);
  }

  private unsubscribe$ = new Subject<void>();

  constructor(private httpClient: HttpClient) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  processUploads(refs: string[]): void {
    // Logic to process bulk recreate orders based on provided IDs
    // /v1/order/cancel-and-recreate-orders
    this.httpClient.post<BulkRecreateOrderResponse[]>(environment.integration.rootUrl+ 'order/recreate-orders', { customer_references: refs },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('id_token')}`
        }
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: BulkRecreateOrderResponse[]) => {
      // Handle the response
        this.recreateOrdersResponse = response;
      });
  }

}

export interface BulkRecreateOrder {
  customer_references: string[];
}

export interface BulkRecreateOrderResponse {
  customer_reference: string;
  new_order_id: string;
  is_success: boolean;
  error_message: string;
}
